import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import { getErrorAndTouched, IField } from './utils';

import { FormikProps } from 'formik';

interface IProps {
  field: IField;
  form: FormikProps<any>;
  label: string;
  numberFormatter: (props: any) => JSX.Element;
}

const FormikNumberFormatter = (props: IProps) => {
  const { field, form, label, numberFormatter, ...other } = props;

  if (!field || !form) {
    return null;
  }
  const {
    touched,
    error
  }: { touched: boolean; error: string } = getErrorAndTouched(form, field);

  const handleChange = (event: any) => {
    event.target.name = field.name;
    field.onChange(event);
  };

  return (
    <TextField
      name={field.name}
      label={label}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      error={!!(touched && error)}
      helperText={!!touched && error}
      InputProps={{
        inputComponent: numberFormatter
      }}
      {...other}
    />
  );
};

export default FormikNumberFormatter;



// WEBPACK FOOTER //
// ./src/common/formik/formik-number-formatter.tsx